import React, { useState } from "react";
import styled from "styled-components";
import ClipLoader from "react-spinners/ClipLoader";

const UploadCard = styled.label`
  border: 2px dashed ${(props) => (props.dragging ? "#0098DB" : "#ccc")};
  border-radius: 8px;
  padding: 80px;
  margin-top: 15px;
  cursor: pointer;
  text-align: center;
  position: relative;
  transition: border-color 0.3s ease-in-out;
`;

const UploadText = styled.div`
  font-family: "Roboto", sans-serif;
  font-size: 1.2rem;
  display: ${(props) => (props.loading ? "none" : "block")};
  pointer-events: ${(props) => (props.loading ? "none" : "auto")};
  opacity: ${(props) => (props.dragging ? 0.5 : 1)};
  transition: opacity 0.3s ease-in-out;
`;

const DocumentUploader = ({ onFileChange, loading, type }) => {
  const [dragging, setDragging] = useState(false);

  let uploadText = "Hacer clic aquí / soltar archivo aquí";

  if (type === "cedula") {
    uploadText = "Adjuntar aquí";
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    onFileChange(file, type);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    onFileChange(file);
    setDragging(false);
  };

  return (
    <UploadCard
      htmlFor="fileInput"
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      dragging={dragging}
    >
      {loading ? (
        <ClipLoader color={"#0098DB"} loading={loading} size={80} />
      ) : (
        <UploadText dragging={dragging}>{uploadText}</UploadText>
      )}
      <input
        type="file"
        accept=".pdf, .jpg, .jpeg, .png"
        onChange={handleFileChange}
        hidden
        id="fileInput"
      />
    </UploadCard>
  );
};

export default DocumentUploader;
